export { default as Img200 } from './processed/200/Hanna.jpg';
export { default as Img400 } from './processed/400/Hanna.jpg';
export { default as Imgthumb } from './processed/thumb/Hanna.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Hanna.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Hanna.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      112,
      81,
      49
    ],
    "_population": 543,
    "_hsl": [
      0.08465608465608464,
      0.3913043478260869,
      0.3156862745098039
    ]
  },
  "LightVibrant": {
    "_rgb": [
      220,
      206,
      178
    ],
    "_population": 27,
    "_hsl": [
      0.1111111111111111,
      0.37500000000000017,
      0.7803921568627451
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      108,
      73,
      36
    ],
    "_population": 29,
    "_hsl": [
      0.08564814814814814,
      0.5,
      0.2823529411764706
    ]
  },
  "Muted": {
    "_rgb": [
      166,
      126,
      84
    ],
    "_population": 3,
    "_hsl": [
      0.08536585365853659,
      0.328,
      0.4901960784313726
    ]
  },
  "LightMuted": {
    "_rgb": [
      193,
      177,
      179
    ],
    "_population": 499,
    "_hsl": [
      0.9791666666666666,
      0.11428571428571427,
      0.7254901960784313
    ]
  },
  "DarkMuted": {
    "_rgb": [
      86,
      58,
      47
    ],
    "_population": 2382,
    "_hsl": [
      0.04700854700854699,
      0.2932330827067669,
      0.2607843137254902
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Hanna.js